<template>
    <div class="view view-analytics-correctness">
        <HeaderAnalyticsCorrectness />
        <HeadingAnalyticsCorrectness
            headingText="Doğruluk: "
            :highlightedText="highlightedTextCorrectnessMode"
            :descText="descTextCorrectnessMode" />
        <FilterbarAnalyticsCorrectness
            categoryLabel="analyticsCorrectness"
            filtertagLabel="correctnessMode" />
        <AnalyticsCorrectnessMode />
        <ChartAnalyticsCorrectnessMode />
        <HeadingAnalyticsCorrectness
            headingText="Genel Doğruluk: "
            :highlightedText="highlightedTextCorrectnessPeriodic"
            :descText="descTextCorrectnessPeriodic" />
        <FilterbarAnalyticsCorrectness
            categoryLabel="analyticsCorrectness"
            filtertagLabel="correctnessPeriodic" />
        <AnalyticsCorrectnessPeriodic />
        <ChartAnalyticsCorrectnessPeriodic />
        <HeadingAnalyticsCorrectness
            headingText="Hatalar: "
            :highlightedText="highlightedTextIncorrects"
            :descText="descTextIncorrects" />
        <FilterbarAnalyticsCorrectness
            categoryLabel="analyticsCorrectness"
            filtertagLabel="incorrects" />
        <AnalyticsIncorrects />
        <BtnChallenge />
        <BtnPracticeModes />
        <Navbar />
    </div>
</template>
<script>
    import HeaderAnalyticsCorrectness from '@/components/HeaderAnalyticsCorrectness.vue';
    import HeadingAnalyticsCorrectness from '@/components/HeadingAnalyticsCorrectness.vue';
    import FilterbarAnalyticsCorrectness from '@/components/FilterbarAnalyticsCorrectness.vue';
    import AnalyticsCorrectnessMode from '@/components/AnalyticsCorrectnessMode.vue';
    import ChartAnalyticsCorrectnessMode from '@/components/ChartAnalyticsCorrectnessMode.vue';
    import AnalyticsCorrectnessPeriodic from '@/components/AnalyticsCorrectnessPeriodic.vue';
    import ChartAnalyticsCorrectnessPeriodic from '@/components/ChartAnalyticsCorrectnessPeriodic.vue';
    import AnalyticsIncorrects from '@/components/AnalyticsIncorrects.vue';
    import BtnChallenge from '@/components/BtnChallenge.vue';
    import BtnPracticeModes from '@/components/BtnPracticeModes.vue';
    import Navbar from '@/components/Navbar.vue';

    export default {
        components: {
            HeaderAnalyticsCorrectness,
            HeadingAnalyticsCorrectness,
            FilterbarAnalyticsCorrectness,
            AnalyticsCorrectnessMode,
            ChartAnalyticsCorrectnessMode,
            AnalyticsCorrectnessPeriodic,
            ChartAnalyticsCorrectnessPeriodic,
            AnalyticsIncorrects,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        computed: {
            highlightedTextCorrectnessMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessMode.type;
                if(selectedFiltertagType === 'last20'){
                    return 'Son 20';
                }
                else if(selectedFiltertagType === 'last100'){
                    return 'Son 100';
                }
            },

            descTextCorrectnessMode(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessMode.type;
                if(selectedFiltertagType === 'last20'){
                    return 'Tamamladığın son 20 pratikteki başarı oranların';
                }
                else if(selectedFiltertagType === 'last100'){
                    return 'Tamamladığın son 100 pratikteki başarı oranların';
                }
            },

            highlightedTextCorrectnessPeriodic(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Haftalık';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Aylık';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Yıllık';
                }
            },

            descTextCorrectnessPeriodic(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessPeriodic.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'Hafta boyunca tamamladığın tüm pratiklerdeki genel başarı oranın';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'Ay boyunca tamamladığın tüm pratiklerdeki genel başarı oranın';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'Yıl boyunca tamamladığın tüm pratiklerdeki genel başarı oranın';
                }
            },

            highlightedTextIncorrects(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.incorrects.type;
                if(selectedFiltertagType === 'last20'){
                    return 'Son 20';
                }
                else if(selectedFiltertagType === 'last100'){
                    return 'Son 100';
                }
            },

            descTextIncorrects(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.incorrects.type;
                if(selectedFiltertagType === 'last20'){
                    return 'Tamamladığın son 20 pratikteki en çok yaptığın hatalar';
                }
                else if(selectedFiltertagType === 'last100'){
                    return 'Tamamladığın son 100 pratikteki en çok yaptığın hatalar';
                }
            },
        }
    };
</script>
<style scoped src="@/css/views/view-analytics-correctness.css"></style>